"use client";

import { BadgeCheck, Handshake, Layers, ShieldCheck, TrendingUp, Zap } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const advantages = [{
  id: "security",
  title: "Security",
  description: "Legally verified documentation ensuring complete clarity and compliance for every trademark transfer under the Trade Marks Act, 1999.",
  icon: ShieldCheck
}, {
  id: "speed",
  title: "Speed",
  description: "Faster market entry without long naming processes. Acquire curated, legally-vetted trademarks and launch your brand in days, not months.",
  icon: Zap
}, {
  id: "growth",
  title: "Growth",
  description: "Curated portfolio of high-potential trademarks designed to accelerate your business expansion across diverse industries.",
  icon: TrendingUp
}, {
  id: "multi-class",
  title: "Multi-Class",
  description: "Multi-class brand assets strategically designed for future expansion into new product and service categories.",
  icon: Layers
}, {
  id: "verified",
  title: "Verified",
  description: "High-quality registered brand names meticulously curated and vetted for immediate acquisition and commercial use.",
  icon: BadgeCheck
}, {
  id: "one-partner",
  title: "One-Partner",
  description: "Your single trusted intermediary for discovery, evaluation, documentation, and seamless end-to-end transactions.",
  icon: Handshake
}];
export default function TheStrategicAdvantage() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="the-strategic-advantage" className="bg-muted py-20 md:py-28">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-16 text-center">
          <h2 className="font-sans text-3xl font-bold tracking-tight text-foreground md:text-4xl">
            The Strategic Advantage
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-lg text-muted-foreground">
            Why leading entrepreneurs and investors choose Business Tantra for premium trademark acquisition.
          </p>
        </div>

        <div ref={ref} className={`grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3 transition-all duration-1000 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
          {advantages.map((adv, i) => <Card key={adv.id} data-index={i} className="h-full border-border/50 bg-card shadow-sm transition-shadow hover:shadow-md">
              <CardHeader className="pb-4">
                <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-lg bg-primary/10">
                  <adv.icon className="h-6 w-6 text-primary" aria-hidden="true" />
                </div>
                <CardTitle className="font-sans text-[20px] font-semibold text-foreground">
                  {adv.title}
                </CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-muted-foreground leading-relaxed">
                  {adv.description}
                </p>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}